<template>
  <div class="tw-pb-8 header tw-max-w-3xl md:tw-m-auto">
    <div class="tw-flex tw-justify-between tw-px-8 tw-pt-2 tw-mb-1 ">
      <p
        class="tw-flex tw-items-center tw-w-64 tw-h-12 tw-text-sm tw-font-medium tw-leading-3 tw-tracking-widest tw-text-black tw-uppercase"
      >
        Replace Player
      </p>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="tw-w-4 tw-h-11"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        @click="handleClose"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </div>

    <form :model="replacePlayer" ref="replacePlayer" class="tw-text-gray-800 ">
      <div class="tw-px-6">
        <div class="tw-pl-2 tw-border-b-2 tw-border-gray-200 tw-mb-7">
          <div class="tw-w-full tw-h-2 tw-mb-2 tw-text-xs tw-font-normal">
            Player being replaced
          </div>
          <input
            disabled
            class="tw-w-full tw-h-5 tw-text-sm tw-font-normal tw-leading-3 tw-text-black tw-bg-transparent tw-bg-white"
            v-model="replacePlayer.oldName"
            :class="replacePlayer.oldName ? 'tw-font-medium' : 'tw-font-normal'"
          />
        </div>

        <div class="tw-pl-2 tw-mb-8 tw-border-b-2 tw-border-gray-200">
          <label class="tw-h-2 tw-mb-2 tw-text-xs tw-font-normal tw-w-72" prop="_id"
            >Replacement player</label
          >
          <select
            class="tw-w-full tw-h-5 tw-text-sm tw-font-normal tw-leading-3 tw-bg-transparent tw-text-black"
            v-model="replacePlayer.newId"
            :class="replacePlayer.newId ? 'tw-font-medium' : ' tw-font-normal'"
          >
            <option disabled value="">Select Player</option>
            <option
              v-for="{ profile, _id } in availablePlayersToAdd"
              :value="_id"
              :key="_id"
              :label="`${profile.firstName} ${profile.lastName}`"
            >
              {{ `${profile.firstName} ${profile.lastName}` }}
            </option>
          </select>
        </div>

        <div class="tw-pl-2 tw-mb-8 tw-border-b-2 tw-border-gray-200" prop="position">
          <select
            v-model="showPosition"
            class="tw-w-full tw-h-5 tw-text-sm tw-font-normal tw-leading-3 tw-bg-transparent tw-text-black"
            :class="showPosition ? 'tw-font-medium' : ' tw-font-normal'"
          >
            <option disabled :value="showPosition">{{ showPosition }}</option>
            <option
              v-for="position in positionsList"
              :label="`${position.name} #${position.number}`"
              :value="position"
              :key="position.number"
              @change="setPosition(position)"
            >
              {{ `${position.name} #${position.number}` }}
            </option>
          </select>
        </div>

        <div class="tw-flex tw-justify-between tw-mb-6">
          <div prop="shirtNum" class="tw-w-1/2 tw-mr-3 tw-border-b-2 tw-border-gray-200">
            <input
              class="tw-w-full tw-h-5 tw-pl-2 tw-text-sm tw-font-normal tw-leading-3 tw-bg-transparent tw-text-black "
              :controls="false"
              v-model="replacePlayer.shirtNum"
              :class="replacePlayer.shirtNum ? 'tw-font-medium' : ' tw-font-normal'"
            />
          </div>

          <div class="tw-w-1/2 tw-border-b-2 tw-border-gray-200 col-24">
            <select
              class="tw-w-full tw-h-5 tw-pl-2 tw-text-sm tw-font-normal tw-leading-3 tw-bg-transparent tw-text-black"
              v-model="replacePlayer.isCaptain"
              placeholder="Select Captaincy"
              :class="replacePlayer.isCaptain ? 'tw-font-medium' : ' tw-font-normal'"
            >
              <option :value="true">Captain (C)</option>
              <option :value="false">Not Captain</option>
            </select>
          </div>
        </div>
      </div>

      <button
        class="tw-justify-center tw-w-11/12 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-py-4 tw-mx-4 tw-text-white tw-bg-green-700 tw-px-auto hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64"
        @click="playerReplaced"
      >
        Replace Player
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: "ReplacePlayer",
  props: {
    playerToChange: { type: Object, required: true },
    availablePlayersToAdd: { type: Array, required: true },
    positionsList: { type: Array, required: true }
  },
  data() {
    return {
      replacePlayer: {
        _id: null,
        position: null,
        showPosition: { name: "" },
        shirtNum: null,
        oldName: null,
        newId: null,
        firstName: "",
        middleName: null,
        lastName: "",
        isPrivate: false,
        isCaptain: false
      },
      playerName: null,
      position: null
    };
  },
  mounted() {
    this.replacePlayer = this.playerToChange;
    this.replacePlayer.oldName = `${this.playerToChange.firstName} ${this.playerToChange.lastName}`;
    if (
      this.playerToChange.position &&
      this.playerToChange.position.name &&
      this.playerToChange.position.number
    ) {
      this.replacePlayer.showPosition = `${this.playerToChange.position.name} #${this.playerToChange.position.number}`;
    }
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    setPosition(position) {
      this.replacePlayer.position = position;
      return `${this.replacePlayer.position.name} #${this.replacePlayer.position.number}`;
    },
    playerReplaced() {
      let newPlayer = this.availablePlayersToAdd.find(x => x._id === this.replacePlayer.newId);
      if (newPlayer) {
        const changedPlayer = {
          _id: newPlayer._id,
          position: this.replacePlayer.position,
          shirtNum: this.replacePlayer.shirtNum,
          firstName: newPlayer.profile.firstName,
          middleName: newPlayer.profile.middleName,
          lastName: newPlayer.profile.lastName,
          isPrivate: newPlayer.profile.isPrivate,
          preferredName: newPlayer.profile.meta.preferredName,
          isCaptain: this.replacePlayer.isCaptain
        };
        this.$emit("changedPlayer", changedPlayer);
      } else {
        this.$emit("changedPlayer", this.playerToChange);
      }
      this.$emit("close");
    }
  },
  computed: {
    showPosition: {
      get() {
        if (this.replacePlayer.position) {
          return `${this.replacePlayer.position.name} #${this.replacePlayer.position.number}`;
        } else {
          return " ";
        }
      },
      set(position) {
        if (position) {
          this.replacePlayer.position = position;
          return `${this.replacePlayer.position.name} #${this.replacePlayer.position.number}`;
        } else {
          return " ";
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  position: relative;
  background: #ffffff;
  border-radius: 8px;

  color: #222222;
}

select {
  appearance: none; /* Remove default arrow */
  background-image: url("../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: -2px;
}
</style>
